// extracted by mini-css-extract-plugin
module.exports = {"field":"field--bbd6aa","field__label":"field__label--81d9cd","field__box":"field__box--707bd0"};